module.exports = __webpack_public_path__ + "img/GideWhiteNRed.2533ee45.jpeg";